import { useEffect } from 'react'
import { useSearchParams } from 'react-router'

import { ENTITY_TAB_EMAILS_MESSAGE_QUERY_PARAM_KEY } from '../../EntityTabEmails.constants'

export function useEntityTabEmailsInitialMessageModal({
  scopeId,
  onOpenMessage,
}) {
  const [searchParams] = useSearchParams()

  const messageUuid = searchParams.get(
    ENTITY_TAB_EMAILS_MESSAGE_QUERY_PARAM_KEY
  )

  // Depend on the message uuid value (not the whole searchParams object) so
  // unrelated query changes (e.g. pagination) don't re-open the pop-up.
  function openInitialMessageModal() {
    if (messageUuid && scopeId) {
      onOpenMessage(messageUuid)
    }
  }

  useEffect(() => {
    openInitialMessageModal()
  }, [messageUuid, scopeId])
}
